// A shipping cutoff is a local time of day. Arrival is counted from the shopper's
// current calendar date, independently of the cutoff and daylight-saving changes.
class CurvilaDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.listeners = new AbortController();
    this.days = Math.max(1, Math.trunc(Number(this.dataset.days)) || 3);
    this.cutoffHour = Math.max(1, Math.min(24, Number(this.dataset.cutoff) || 24));
    this.formatDate = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month: 'short', day: 'numeric', timeZone: 'UTC'});
    this.remaining = this.querySelector('[data-remaining]');
    this.arrival = this.querySelector('[data-arrival]');
    this.dispatchLabel = this.querySelector('[data-dispatch]');
    if (!this.remaining || !this.arrival || !this.dispatchLabel) return;
    const options = {signal: this.listeners.signal};
    document.addEventListener('visibilitychange', this.tick, options);
    window.addEventListener('pageshow', this.tick, options);
    this.tick();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    this.listeners.abort();
  }

  tick = () => {
    clearTimeout(this.timer);
    const now = new Date();
    const year = now.getFullYear(), month = now.getMonth(), day = now.getDate();
    let cutoff = new Date(year, month, day, this.cutoffHour);
    const afterCutoff = now >= cutoff;
    if (afterCutoff) cutoff = new Date(year, month, day + 1, this.cutoffHour);

    // Start with the visitor's local year/month/day. UTC here is just a stable
    // calendar for adding whole dates, including across DST and month boundaries.
    const arrival = new Date(Date.UTC(year, month, day + this.days));
    if (!Number.isFinite(arrival.getTime())) return;
    const iso = arrival.toISOString().split('T')[0];
    if (this.arrival.dateTime !== iso) {
      this.arrival.dateTime = iso;
      this.arrival.textContent = this.formatDate.format(arrival);
      this.querySelector('[data-fallback]').hidden = true;
      this.querySelector('[data-clock]').hidden = false;
      this.querySelector('[data-schedule]').hidden = false;
    }
    const dispatch = afterCutoff ? this.dataset.tomorrow : this.dataset.today;
    if (this.dispatchLabel.textContent !== dispatch) this.dispatchLabel.textContent = dispatch;

    const seconds = Math.ceil((cutoff - now) / 1000);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds / 60) % 60;
    const tail = String(seconds % 60).padStart(2, '0');
    this.remaining.textContent = hours
      ? [hours, minutes, seconds % 60].map(value => String(value).padStart(2, '0')).join(':')
      : minutes + 'm ' + tail + 's';

    if (!document.hidden) this.timer = setTimeout(this.tick, 1000 - now.getMilliseconds() + 5);
  };
}
if (!customElements.get('cv-delivery-estimate')) customElements.define('cv-delivery-estimate', CurvilaDeliveryEstimate);
